<smart-table [headers]="headers"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [source]="source">

  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="value" let-item>
    <td>
      {{ item.value }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="diff" let-item>
    <td>
      {{ item.diff }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="action" let-item>
    <td>
      {{ item.action?.key }} <br>
      <small class="text-muted">{{ item.action?.id }}</small>
    </td>
  </ng-template>

  <ng-template smartTableColumn="purchase" let-item>
    <td>
      <entity-link type="purchase" [item]="item.purchase" [name]="item.purchase?.productType" [showInfo]="false"></entity-link>
      <br>
      <small class="text-muted">{{ item.action?.id }}</small><br>
      <small class="text-muted">{{ item.action?.createdAt | moment:'dmyhm' }}</small>
    </td>
  </ng-template>

  <ng-template smartTableColumn="updatedAt" let-item>
    <td>
      {{ item.updatedAt | moment }}
    </td>
  </ng-template>

</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>


